module.exports = __webpack_public_path__ + "static/media/mobile14.a2909740.png";